<template>
    <div>
        <div class="flex mb-2" :class="hasComments ? 'justify-between' : 'justify-end'">
            <!-- <USelect v-if="hasComments" variant="underline" color="amazon" :options="SelectSort" v-model="sort" /> -->
            <div></div>
            <UButton icon="i-solar-add-circle-line-duotone" @click="handleReply(undefined)">ثبت نظر جدید</UButton>
        </div>
        <PagesProductCommentsList :comments="comments" @reply-comment="handleReply" />
        <UModal v-model="openAddNewComment">
            <LazyPagesProductCommentsNewComment :reply-to="replyToComment" @close="openAddNewComment = false" />
        </UModal>
    </div>
</template>

<script lang="ts" setup>
import type { IComment } from "~/libs/types/api/comments";

const props = defineProps({
    comments: Object as PropType<IComment[]>,
});

const SelectSort = [
    {
        label: "محبوب‌ترین",
        value: "trend",
    },
    {
        label: "جدیدترین",
        value: "new",
    },
    {
        label: "قدیمی‌ترین",
        value: "old",
    },
];

const openAddNewComment = ref(false);
const sort = ref(SelectSort[0].value);
const replyToComment = ref();

function handleReply(i: number | undefined) {
    if (typeof i === "number") replyToComment.value = props.comments?.[i];
    else replyToComment.value = i;
    openAddNewComment.value = true;
}

const hasComments = computed(() => {
    return !(!props.comments || props.comments.length === 0);
});
</script>

<style></style>
